export default __webpack_public_path__ + "static/media/increase.036ea4e6.svg";